import { createTheme, ThemeOptions } from "@mui/material/styles";

const themeOptions: ThemeOptions = {
  palette: {
    primary: {
      main: "rgba(255, 204, 0, 1)",
      light: "rgba(255, 224, 102, 1)",
      dark: "rgba(153, 122, 0, 1)",
      contrastText: "rgba(255, 255, 255, 1)",
    },
    secondary: {
      main: "rgba(212, 5, 17, 1)",
      light: "rgba(251, 71, 81, 1)",
      dark: "rgba(115, 3, 9, 1)",
    },
    text: {
      primary: "rgba(0, 0, 0, 0.9)",
      secondary: "rgba(0, 0, 0, 0.5)",
      disabled: "rgba(0, 0, 0, 0.3)",
    },
    error: {
      main: "rgba(255, 98, 98, 1)",
      dark: "rgba(250, 0, 0, 1)",
      light: "rgba(255, 173, 173, 1)",
      contrastText: "#ffffff",
    },
    warning: {
      main: "rgba(255, 170, 0, 1)",
      light: "rgba(255, 204, 102, 1)",
      dark: "rgba(153, 102, 0, 1)",
      contrastText: "rgba(255, 255, 255, 1)",
    },
    info: {
      main: "rgba(2, 136, 209, 1)",
      light: "rgba(3, 169, 244, 1)",
      dark: "rgba(1, 87, 155, 1)",
    },
    success: {
      main: "rgba(64, 221, 127, 1)",
      light: "rgba(151, 237, 185, 1)",
      dark: "rgba(28, 156, 79, 1)",
      contrastText: "#ffffff",
    },
    grey: {
      100: "#6c6b6b",
    },
    divider: "rgba(0, 0, 0, 0.12)",
    background: {
      paper: "#ffffff",
      default: "#ffffff",
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#ffcc00",
          color: "rgba(0, 0, 0, 0.9)",
          background:
            "linear-gradient(" +
            "90deg, " +
            "rgb(255, 204, 0) 0%, " +
            "rgb(255, 204, 0) 30%, " +
            "rgb(255, 222, 89) 79%, " +
            "rgb(255, 240, 178) 100%" +
            ")",
        },
      },
    },
  },
  typography: {
    fontFamily: "Delivery Regular",
    overline: {
      fontFamily: "Delivery Regular",
    },
    button: {
      fontFamily: "Delivery Regular",
    },
    body2: {
      fontFamily: "Delivery Regular",
    },
    body1: {
      fontFamily: "Delivery Regular",
    },
    subtitle2: {
      fontFamily: "Delivery Regular",
    },
    subtitle1: {
      fontFamily: "Delivery Regular",
    },
    h6: {
      fontFamily: "Delivery Regular",
    },
    h5: {
      fontFamily: "Delivery Regular",
    },
    h4: {
      fontFamily: "Delivery Regular",
    },
    h3: {
      fontFamily: "Delivery Regular",
    },
    h2: {
      fontFamily: "Delivery Regular",
    },
    caption: {
      fontFamily: "Delivery Regular",
    },
    h1: {
      fontFamily: "Delivery Regular",
    },
  },
};

export const DhlTheme = createTheme(themeOptions);
